export default "__VITE_ASSET__tHq09J_8__"